import { SessionStorageKey } from 'shared/constants/sessionStorage'

/** Stable per browser-tab id included in focus broadcast payloads. */
export const getContainerTabId = (): string => {
  let id = sessionStorage.getItem(SessionStorageKey.CONTAINER_TAB_ID)
  if (!id) {
    id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
    sessionStorage.setItem(SessionStorageKey.CONTAINER_TAB_ID, id)
  }
  return id
}
